import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { LocalStorageService } from 'ngx-store';

@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.css']
})
export class ThemeComponent implements OnInit {
  state = 'black';
  username;
  name = 'Chat now';
  color = {
    color1: '',
    color2: '',
    color3: '',
    color4: '',
    color5: '',
    color6: '',
  };
  items = [
    { name: "mad", timeStamp: "2019-09-04T15:42:43.885Z", title: "test 0" },
    { name: "psm", timeStamp: "2019-09-04T15:42:43.885Z", title: "test 1" },
    { name: "mad", timeStamp: "2019-09-04T15:42:43.885Z", title: "test 2" }
  ];
  themeRf;
  themeColor;
  constructor(private ls: LocalStorageService, private afd: AngularFireDatabase, ) {
    this.themeRf = afd.list("theme");
    this.themeColor = this.themeRf.snapshotChanges().map(changes => {
      // this.lastSeen = new Date().toISOString();
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
  }

  ngOnInit() {
    this.username = this.ls.get('username');
    this.themeRf.valueChanges().subscribe(theme => {
      if (theme.length > 0) {
        let newArr = theme.filter(val => {
          if (val.theme.name == this.username) {
            return val;
          }
        });
        if (newArr.length > 0) {
          console.log('theme', newArr);
          this.color.color1 = newArr[0].theme.properties['--p-header'];
          this.color.color2 = newArr[0].theme.properties['--p-header-txt'];
          this.color.color3 = newArr[0].theme.properties['--p-background'];
          this.color.color4 = newArr[0].theme.properties['--p-txt-color'];
          this.color.color5 = newArr[0].theme.properties['--p-chat-txt-bg'];
          this.color.color6 = newArr[0].theme.properties['--p-chat-rx-txt-bg'];
          console.log('theme', this.color);
        }
      }
    });
  }

  header(e) {
    console.log('e', e);
    if (e.color.hex) {
      this.color.color1 = e.color.hex
      document.documentElement.style.setProperty('--p-header', this.color.color1);
    }
  }

  headerTxt(e) {
    console.log('e', e);
    if (e.color.hex) {
      this.color.color2 = e.color.hex
      document.documentElement.style.setProperty('--p-header-txt', this.color.color2);
    }
  }

  background(e) {
    if (e.color.hex) {
      this.color.color3 = e.color.hex
      document.documentElement.style.setProperty('--p-background', this.color.color3);
    }
  }

  textColor(e) {
    if (e.color.hex) {
      this.color.color4 = e.color.hex
      document.documentElement.style.setProperty('--p-txt-color', this.color.color4);
    }
  }

  chatTxtBg(e) {
    if (e.color.hex) {
      this.color.color5 = e.color.hex
      document.documentElement.style.setProperty('--p-chat-txt-bg', this.color.color5);
    }
  }

  chatAnotherTxtBg(e) {
    if (e.color.hex) {
      this.color.color6 = e.color.hex
      document.documentElement.style.setProperty('--p-chat-rx-txt-bg', this.color.color6);
    }
  }

  save() {
    const theme = {
      name: this.ls.get('username'),
      mode: 'light',
      properties: {
        '--p-header': this.color.color1 ? this.color.color1 : '#673ab7',
        '--p-header-txt': this.color.color2 ? this.color.color2 : '#ffffff',
        '--p-background': this.color.color3 ? this.color.color3 : 'hsl(0, 0%, 98%)',
        '--p-txt-color': this.color.color4 ? this.color.color4 : '#ffffff',
        '--p-chat-txt-bg': this.color.color5 ? this.color.color5 : '#673ab7',
        '--p-chat-rx-txt-bg': this.color.color6 ? this.color.color6 : '#6c757d'
      }
    }
    this.ls.set('theme', theme);
    this.themeRf.push({
      theme: theme
    });
  }


}
